import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 38 104"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#000",
      d: "M37.5.5v103H.5V.5z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000",
      d: "M12.895 57v-.714l4.074-3.99q.56-.546.84-.952.279-.42.378-.784a2.6 2.6 0 0 0 .098-.686q0-.854-.588-1.344-.574-.49-1.708-.49-.868 0-1.54.266a2.9 2.9 0 0 0-1.134.826l-.714-.616a3.75 3.75 0 0 1 1.47-1.036q.895-.364 2.002-.364.993 0 1.722.322.727.308 1.12.91.405.602.406 1.414 0 .476-.14.938a3.4 3.4 0 0 1-.476.98q-.337.504-.994 1.148l-3.738 3.668-.28-.392h6.076V57zm8.195-6.972.616-2.576.112.588a.8.8 0 0 1-.546-.196.74.74 0 0 1-.21-.546q0-.336.21-.546.223-.21.532-.21.321 0 .518.224.21.21.21.532 0 .113-.014.224a1.6 1.6 0 0 1-.056.252 3 3 0 0 1-.098.322l-.602 1.932zm2.38 0 .616-2.576.112.588a.8.8 0 0 1-.546-.196.74.74 0 0 1-.21-.546q0-.336.21-.546.223-.21.532-.21.321 0 .518.224.21.21.21.532 0 .113-.014.224a1.6 1.6 0 0 1-.056.252 3 3 0 0 1-.098.322l-.602 1.932z"
    }, null, -1)
  ])))
}
export default { render: render }